<template>
  <div>
    <el-row style="background-color: #242424">
      <el-col :span="!isDemo ? 10 : 0" style="padding: 5px">
        <div v-if="!isDemo">
          <img v-if="isEscondida" src="@/assets/logo-escondida.png" class="escondida" />
          <img v-else src="@/assets/logo_blanco.svg" class="bhp" />
        </div>
      </el-col>
      <el-col :span="14" style="padding: 5px">
        <Roles :roles="$store.getters.roles" :currentRole="$store.getters.role" />
      </el-col>
    </el-row>
    <div class="fondoTextura paddingText">
      <el-row>
        <el-col style="padding-top: 6px" :span="13">
          <h2 class="subtitle whiteColor">{{ $store.getters.subtitle }}</h2>
        </el-col>
        <el-col :span="11" style="text-align: right">
          <div v-if="$route.name === 'editInventoryPage' ||
            $route.name === 'checkInventoryPage' ||
            $route.name === 'inventoryShowPage'
          " style="display: inline; margin-right: 15px;" class="subtitle whiteColor">
            <span style="font-size: 13px; margin-right: 10px"><b>Estado Inventario:</b> </span>
            <el-tag size="small" :class="`inventario_estado inventario_estado_${$store.getters.status}`">{{
              $t(inventario_estado[$store.getters.status]) }}</el-tag>
          </div>
          <el-popover placement="bottom" width="400" trigger="click" v-if="[
            '642198cb8c03c500123c0d94',
            '655ca26350599500126cc6e2',
            '5e41686693114800178f246f',
            '5b929a761616050010f76dff',
            '59cbfb0c0a1d7d0011ba7860',
          ].includes($store.getters.user._id)
          ">
            <div style="max-width: 500px; overflow: auto;">
              <div style="margin-bottom: 10px"><b>Solicitudes de contratos recibidas</b></div>
              <el-alert v-for="(item, i) in notifications" :key="`${i}-Notifications`" @close="visto(item._id)"
                :title="faenas[item.faena_id]" style="padding: 0px; margin-bottom: 10px;" type="warning">
                <small style="font-size: 12px;">
                  <b>Fecha</b>: {{ dateFromObjectId(item._id) }}<br>
                  <span v-if="item.nombre_empresa"><b>Empresa</b>: {{ item.nombre_empresa }}<br></span>
                  <b>Código</b>: {{ item.codigo }}
                </small>
                <br>

                <el-button-group style="margin-top: 10px;">
                  <el-button @click="goNotificacion(item)" type="primary" size="mini">Atender solicitud</el-button>
                  <el-button @click="visto(item._id)" type="danger" size="mini">Eliminar notificación</el-button>
                </el-button-group>
              </el-alert>
              <el-empty v-if="notifications.length === 0" :image-size="100"></el-empty>
            </div>
            <el-button :class="{ 'alerts-border': notifications.length > 0 }"
              :type="notifications.length > 0 ? '' : 'success'" slot="reference"
              style="font-weight: bold; margin-right: 7px; float: right;" size="mini">
              NOTIFICACIONES
              <span
                style="margin-left: 2px; background-color: red; color: white; border-radius: 100%; padding: 2px 4px 2px 4px;">{{
                  notifications.length || 0 }}</span></el-button>
          </el-popover>
          <!-- <el-dropdown trigger="click" @command="handleChange" size="small" split-button>
            <b>Seleccione Idioma <i class="el-icon-location-outline"></i></b>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="es" style="width: 150px"><img width="20px;" style="margin-right: 7px"
                  src="@/assets/flags/es.png" alt="Español" /><b>ESPAÑOL</b></el-dropdown-item>
              <el-dropdown-item command="en"><img width="20px;" style="margin-right: 7px" src="@/assets/flags/en.jpg"
                  alt="English" /><b>INGLÉS</b></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Trans } from "@/helpers/i18n";
import { includes } from "lodash";
import { reviewerRoles, coordinatorRoles } from "@/utils/generalObjects";
import Roles from "./Roles.vue";
import TranslationSwitch from "@/components/TranslationSwitch.vue";

const FAENAS_ESCONDIDA = [
  "5a6345a53ad308a85c17a118",
  "5a6f78337b772dcfe68241d5",
];

const FAENA_DEMO = [
  '64a65c1002ea56559c3c8b80'
];

export default {
  name: "navbar",
  data() {
    return {
      faenas: {
        "5a6f78337b772dcfe68241d5": "Minera Escondida",
        "5a6f78417b772dcfe68241e5": "Minera Spence",
        "5a6f784e7b772dcfe68241f4": "Minera Cerro Colorado",
        "5b48f15d6f0ed90fc02826e3": "BHP",
        "5c262b3176851b775b8bdefc": "Safety Club",
      },
      inventario_estado: {
        "0wasApproved": "Aprobado en actualización",
        "1wasApproved": "Aprobado en actualización",
        undefined: "No Iniciado",
        0: "Borrador",
        1: "En Revisión",
        2: "Aprobado",
        3: "Importado Borrador",
        4: "Validación de Medioambiente",
      },
      reviewerRoles,
      coordinatorRoles,
      bhpProfiles: {
        hse: "HSE",
        health: "Especialista de Salud",
        safety: "Especialista de Seguridad",
        environment: "Especialista de Medioambiente",
        contractor_hse: "HSE Contratista",
        owner: "Dueño de Contrato",
        contract_owner: "Dueño de Contrato",
        risk: "Especialista de Riesgo",
        administrator: "Administrador de Contrato",
        contractor_coordinator: "Coordinador Contratista",
        coordinator: "Coordinador",
        manager: "Gerente",
        super: "Superintendente",
        general_manager: "Gerente General",
        superadmin: "Administrador del sistema",
        faena_selected: null,
        rol_selected: null
      },
    };
  },
  components: {
    Roles,
    TranslationSwitch,
  },
  mounted() {
    this.statusNotifications();
    this.execute1();
  },
  computed: {
    notifications() {
      return this.$store.getters.notifications;
    },
    isDemo() {
      return includes(FAENA_DEMO, this.$store.getters.role.faena_id);
    },
    isEscondida() {
      try {
        return includes(FAENAS_ESCONDIDA, this.$store.getters.role.faena_id);
      } catch (error) {
        console.log(error);
      }
    },
  },
  methods: {
    async setData(id, role) {
      this.rol_selected = role;
      const newRole = {
        faena_id: this.faena_selected,
      };
      newRole.admin = true;
      // Role
      newRole.role = role;
      // ultimo estado
      const latest_state = {
        faena_selected: this.faena_selected,
        type_user: "superadmin",
        empresa_selected: null,
        rol_selected: this.rol_selected,
        area_selected: null,
      };
      // reset datos de otros roles
      await this.$store.dispatch("resetEmpresasFaena");
      await this.$store.dispatch("resetAreas");
      await this.$store.dispatch("resetContract");
      await this.$store.dispatch("resetUserContractByRole");
      await this.$store.dispatch("latestState", latest_state);
      await this.$store.dispatch("setRole", newRole);
      await this.$store.dispatch("setAllRiesgosPendientes", null);
    },
    async goNotificacion(item) {
      this.faena_selected = item.faena_id;
      await this.setData(null, "admin");
      await this.$router.push("/admin/soporte").catch(() => { });
      this.$store.dispatch("setTareaVista", "");
      this.$store.dispatch("setNotificationSelected", {});
      this.$store.dispatch("setNotificationSelected", item);
    },
    async statusNotifications() {
      this.$store.dispatch("getNotifications");
    },
    async visto(_id) {
      this.$store.dispatch("offNotifications", _id);
      this.statusNotifications();
    },
    dateFromObjectId(objectId) {
      var d = new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
      return d = d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear() + ' ' + (d.getHours() > 12 ? d.getHours() - 12 : d.getHours()) + ':' + d.getMinutes() + ' ' + (d.getHours() >= 12 ? "PM" : "AM");
    },
    async execute1() {
      while (true) {
        await new Promise((resolve) => setTimeout(resolve, 30000));
        this.statusNotifications();
      }
    },
    handleChange(lang) {
      const currentLang = this.$i18n.locale;
      const currentPath = this.$router.history.current.path;

      this.$router.push(currentPath.replace(`/${currentLang}`, `/${lang}`));

      Trans.changeLanguage(lang);
    },
  },
};
</script>

<style scoped>
.mt-10 {
  margin-top: 10px;
}

.escondida {
  width: 210px;
  margin-top: 2px;
  margin-left: 5px;
}

.bhp {
  width: 63px;
  margin-top: 2px;
  margin-left: 5px;
}

.username {
  font-weight: 800;
  font-size: 18px;
}

.user-info {
  font-size: 14px;
}

.centrar {
  text-align: center;
}

.infoRole {
  margin-top: 15px;
  color: white;
  font-size: 25px;
}

.cursor {
  cursor: pointer;
}

.info {
  margin-left: 5px;
  font-size: 18px !important;
}

.inventario_estado {
  color: white;
  font-weight: 600;
  border-radius: 3px;
  font-size: 14px;
}

.inventario_estado_vencido {
  background-color: #b84858;
}

.inventario_estado_undefined {
  background-color: red;
  border: 1px solid black;
}

.inventario_estado_0 {
  background-color: grey;
}

.inventario_estado_0wasApproved {
  background-color: grey;
}

.inventario_estado_1 {
  background-color: #e4d306;
  color: black;
}

.inventario_estado_1wasApproved {
  background-color: #e4d306;
  color: black;
}

.inventario_estado_2 {
  background-color: #6bc45b;
}

.inventario_estado_3 {
  background-color: orange;
}

.inventario_estado_4 {
  background-color: #e4d306;
}

.fondoTextura {
  background-image: url(../assets/fondo.png);
}

.whiteColor {
  color: white;
}

.title {
  margin: 0;
  font-size: 22px;
}

.subtitle {
  font-size: 16px;
  margin: 0;
}

.paddingText {
  padding: 6px;
}

.alerts-border {
  border: 3px black solid;

  animation: blink 1s;
  animation-iteration-count: infinite;
}

@keyframes blink {
  50% {
    border-color: #fff;
  }
}
</style>
